export const lang = {
    header:{
        home:'HOMEPAGE',
        aboutUs:'ABOUT US',
        service:'OUR BUSINESS',
        concatUs:'CONTACT US',
    },
    homePage:{
        senseOfWorth:'Core values',
        corporateMission:'Our Mission',
        strategic:'Strategic Goal',
        detail1:'Creativity,Capacity,Cooperation,Competition',
        detail2:'Connect Arab with Better Games',
        detail3:'Affect Every Arab User and Make Life Better.',
        teamAtrength1:'Arab Online keeps a tight touch with local dubbing experts, KOL and MBC, owning primary source of media marketing. ',
        teamAtrength2:'Arab Online was founded by arabic game experts. Having gathered the professions from iGG, NetDragon, ONEMT, ByteDance and other famous IT companies. Arab Online owns rich experience of publishing mobile games.',
        teamAtrength3:'With internal cohesive force and enthusiasm for games, all ArabOnliners keep striving for a better user experience by offering the greatest localization and publishing service for all content providers.',
        faxingyw:'Game Publishing',
        bendihYw:'Localization',
        cpyr:'New Products In',
        swpphz:'Business/Brand Partnership',
        qdhz:'Advertisement Cooperation',
        jrqm:'Join Us',
        m2016: 'The company was established, and the first co-published game “INVASION” was launched in November',
        m2017: 'Launched the co-published mobile game WARFARE STRIKE',
        m2018: 'INVASION ranked as 3rd (OVERALL) and 2nd (GAME) in MENA Grossing Rank',
        m2019: 'Launched the co-published mobile game VAMPIRE EMPIRE',
        m2020: 'Finished localization for multiple games.',
        readMore: 'Read More',
        rmal: 'SHOWCASE',
        gs: 'ABOUT COMPANY',
        fl: 'LAWS',
        gsfzlc: 'Team Development',
        tdsl: 'Team Members',
        gsyj: 'VISION',
        zpzs: 'Showcase',
        publishProject: 'Co-publish Project',
        AboutUs: 'About Us',
        cookie: 'Cookie Policy',
        sytk: 'Terms of Use'
    },
    business:{
        invasion:{
            a1:'Game',
            a2:'Developer',
            a3:'Brief Introduction:',
            a4:'Having been featured  by AppStore at a great length, Invasion is the most popular SLG developed by Tap4Fun from Chengdu. It\'s a war-themed game that challenges players to conquer and battle their  way to world domination in the midst of a global apocalypse.',
            a5:'Way of Cooperation:',
            a6:'Localization & Co-Publishing',
            a7:'Highlight：',
            a8:'Inviting Haifa Wahbe as the spokesperson to the official launch, Invasion has become the first Arabic mobile game to unite with pop star in MENA history.',
            a9:'Featured in AppStore and Google Play homepage many times from 2016 to 2020.',
            a10:'Reached the revenue milestone of 2 million Dollars and top-ranked for more than 1 year in GCC.',
        },
        warfare:{
            a4:'Warfare Strike is a brand new multiplayer SLG war game customized for Arabic players.   Players can compete with friends and experience the fun of battle.  To become the real   king in this troubled world by making rational use of the right time and place and  managing the city\'s resources.',
            a5:'Localization & Co-Publishing',
            a6:'The high ARPPU(Average Revenue Per Paid User)makes the most prominent feature  of this game.',
            a7:'Ranked Top20 Grossing Games of Saudi Arabia.',
        },
        clashForDawn:{
            a4:'Clash for Dawn tells the story of the Midgard Continent facing the invasion of the army, dragons and other evil forces. Players can play warriors, mages, archers, priests and other types of classes to resolve the catastrophe together with human.',
            a5:'Localization & Co-Publishing',
            a6:'Clash for Dawn is the first ARPG that has been localized and published in Middle East by ArabOnline.',
            a7:'Have explored  the acceptability of magic MMO in Middle East.'
        },
        totalDestruction:{
            a4:'Total Destruction is a multiplayer online strategy game. The background of this game is set in an era of disputes between great empires. A war broke the balance and the  tributary countries start to crown themselves as the Kings one after another, and they are fighting for the King of the mainland. In the game, players can play as the king, build city, recruit troops, and build a new epic nation.',
            a5:'Localization&Publishing',
            a6:'ArabOnline combined Total Destruction with war history and culture of Middle East,rebuilding the story and world view,which resonated Arab players and got much feedback that they really liked this story.',
            a7:'Cooperated with local famous dubbing  team  to output the BGM, which has been highly praised by CP and Arab players.',
            a8:'Ideas for advertisement are geographically-based,architectural-based,custom-based and language-based that all creative content is exclusive for Arab players.',
            a9:'Multiple ideas and professional campaign management make the  best-performanced CTR exceed 4% and the overall CTR2% and the CVR20.47% in the end.'
        },
        vampireEmpire:{
            a4:'Vampire Empire is a strategic mobile game based on the Medieval,telling the story of vampires and human beings fight for survival and dominance for hundreds of years.',
            a5:'Localization & Co-Publishing',
            a6:'The voice actor who had dubbed the Arabic version of the Disney movie The Lion King participated in the vampire Dracula passionately.',
            a7:'Made the complete  marketing plan and kept an eye on the 3rd party tracking and optimized the performance of advertisement.',
            a8:'Outstanding and creative design of banners and videos,making  the overall average click-through-rate 1.48% and conversion rate 20.62%.',
            kaifashang:'Gekko Game',
            name:'Vampire Empire'
        },

        powerAndHonor:{
            a4:'Power and Honor is the magic MMORPG set in Madieval,telling the story of disputes between 6 different kingdoms developed by  Archosaur Games. Power and Honor is the first self-developed and self-published 3D mobile MMORPG of Archosaur Games.',
            a5:'Localization',
            a6:'Have further optimized the localization of heroes to make them look more conform to the aesthetic of Arabic people.',
            a7:'Have adjusted  the language,way of reading,UI to adapt to the local people.',
            kaifashang:'Archosaur Games'
        },
        brutalAge:{
            a4:'Brutal Age is a free MMO strategy game that players can experience the primitive huntings and intensive fights between players from all over the world.',
            a5:'Localization',
            a6:'Invite local authoritative experts to join this project to ensure the native translation.',
            a7:'Dubbing team have studied and researched  the way that the primitive man make the sound and present almost exactly the same  performance to Arabic players.',
            a8:'The art team design the Arabic primitive man according to the prominent features that Arabic people have and vividly present the Arabic heroes.',
            a9:'KOL Marketing contributes to ​full exposure in the Middle East when launching this game.',
            kaifashang:'Tap4Fun',
            name:'Brutal Age'
        },
        thisNew:{
            a4:'This New is a DIY shopping product aimed at Arab people. It is committed to helping   consumers choose their favorite products for DIY with exclusive customization and infinite personality.',
            a5:'Localization',
            a6:'This New is the first e-commerce tool software that ArabOnline localized.',
            a7:'From UI  to the color-matching and lanague, ArabOnline spares no effort offering the best advice to present a more Arabic appearance closed  to the preference of e-commerce industry in Arab.',
            kaifashang:'ZiXun',
            name:'This New'
        },
        gameOfKings:{
            a4:'Game of Kings:The Blood Throne is a completely free real-time strategy mobile game about medieval wars.Player can fight bloody battles with enemies, dragons and monsters to become the king.',
            a5:'Localization',
            a6:'ArabOnline has much in similar value and concept in game localization with developer,so the overall communication is very smooth and efficient.',
            kaifashang:'Koofei',
            name:'Game of Kings'
        },
        warOfSteel:{
            a4:'War of Steel is a modern war strategy game simulating the development, cooperation and conflict between cities in a chaotic age.',
            a5:'Localization',
            a6:'ArabOnline has helped rebuild the background story and world view.',
            a7:'Fully localized the heroes and scenes to highly match the interest of Arab players.',
            kaifashang:'iLead',
            name:'War of Steel'
        },
    },
    invasion:{

    },
    login: 'login',
    register: 'register',
    welcome: 'welcome',
    logout: 'logout'
}


// WEBPACK FOOTER //
// ./src/components/lang/en.js